import { getApplicationSettings } from 'owa-application-settings';
import mailReadRouteHandler from './mailReadRouteHandler';
import type { MailReadRouteParameters } from './mailReadRouteHandler';

export default async function applinkMailReadRouteHandler(
    parameters: MailReadRouteParameters
): Promise<void> {
    if (getApplicationSettings('PlatformType').isMonarch) {
        return mailReadRouteHandler(parameters);
    }

    // If not in Monarch, redirect to deeplink for OWA.
    // Interim solution for users who have popouts blocked
    const { itemId, domain, account } = parameters;

    if (itemId) {
        const encodedItemId = encodeURIComponent(itemId);

        if (domain && account) {
            window.location.replace(
                window.origin + `/mail/deeplink/read/account/${domain}/${account}/${encodedItemId}`
            );
            return;
        }

        window.location.replace(window.origin + '/mail/deeplink/read/' + encodedItemId);
    }
}
